import { Button, Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import { ShortcutMenuProps } from "../interfaces/Toolbar";
import {
  Arrow90degLeft,
  Arrow90degRight,
  WindowDock,
} from "react-bootstrap-icons";

//!props.showShapes && !props.showTransitions && !props.showHeatmap && !props.showOrientations &&
export function ShortcutMenu(props: ShortcutMenuProps) {
  return (
    <div className="mb-3">
      {props.editingModeActive && !props.show3DView && !props.showHeatmap && (
        <Tabs
          defaultActiveKey="profile"
          id="uncontrolled-tab-example"
          className="extra-border"
        >
          <Tab className="mb-3" eventKey="orientation" title="Orientation">
            <Button
              className="ms-3 mb-3 mt-3"
              variant="secondary"
              disabled={props.brushCopy.length <= 0}
              onClick={(e) =>
                props.rotateLeft(props.selectedPattern, props.brushCopy)
              }
            >
              <Arrow90degLeft />
              {"  Left"}
            </Button>
            <Button
              className="ms-1"
              variant="secondary"
              disabled={props.brushCopy.length <= 0}
              onClick={() => {
                props.activateOrientations();
                props.setShowOrientationModal(true);
              }}
            >
              {"Edit orientations  "} <WindowDock />
            </Button>
            <Button
              className="ms-1"
              variant="secondary"
              disabled={props.brushCopy.length <= 0}
              onClick={(e) =>
                props.rotateRight(props.selectedPattern, props.brushCopy)
              }
            >
              {"Right  "}
              <Arrow90degRight />
            </Button>
          </Tab>
          <Tab eventKey="tangentBodyPart" title="Point">
            <Button
              variant="secondary"
              className="ms-3 mt-3 mb-3"
              disabled={props.brushCopy.length <= 0}
              onClick={() => {
                props.activateTangentBodyParts();
                props.setShowFootModal(true);
              }}
            >
              {"Edit point  "} <WindowDock />
            </Button>
          </Tab>
          <Tab eventKey="Rotation" title="Rotation">
            <Form.Group className="mb-3 ms-3" as={Row}>
              <Row>
                <Col xs="12">
                  <Form.Label className="mt-3">
                    Rotate <b>arbitrary</b> structures
                  </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs="5">
                  <Form.Range
                    value={props.brushRotationAngle}
                    onChange={(e) => {
                      props.setBrushRotationAngle(+e.target.value);
                    }}
                    min={-180}
                    max={180}
                    step={45}
                  />
                </Col>
                <Col xs="7">
                  <Form.Label className="me-3">
                    {props.brushRotationAngle + "°"}
                  </Form.Label>

                  <Button
                    variant="primary"
                    disabled={props.brushCopy.length <= 0}
                    onClick={(e) => {
                      props.deactivateAllModes();
                      props.rotateBrush(
                        props.selectedPattern,
                        props.brushCopy,
                        props.copyOfFirstDancer,
                        props.brushRotationAngle
                      );
                    }}
                  >
                    Rotate
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Tab>
          <Tab eventKey="Scale" title="Scale">
            <Form.Group className="mb-3 ms-1" as={Row}>
              <Row>
                <Col xs="12">
                  <Form.Label className="mt-3">
                    Scale <b>symmetric</b> structures
                  </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col xs="10">
                  Horizontal{" "}
                  <input
                    type="number"
                    style={{ width: "80px" }}
                    className="me-2"
                    min="0.5"
                    max="2"
                    step="0.5"
                    value={props.formScalingFactor[0]}
                    onChange={(e) => {
                      props.deactivateAllModes();
                      const temp = props.formScalingFactor[1];
                      props.setFormScalingFactor([+e.target.value, temp]);
                    }}
                  ></input>
                  Vertical{" "}
                  <input
                    type="number"
                    style={{ width: "80px" }}
                    className="me-3"
                    min="0.5"
                    max="2"
                    step="0.5"
                    value={props.formScalingFactor[1]}
                    onChange={(e) => {
                      props.deactivateAllModes();
                      const temp = props.formScalingFactor[0];
                      props.setFormScalingFactor([temp, +e.target.value]);
                    }}
                  ></input>
                  <Button
                    variant="primary"
                    disabled={props.brushCopy.length <= 0}
                    onClick={(e) => {
                      props.deactivateAllModes();
                      props.scaleBrush(
                        props.selectedPattern,
                        props.brushCopy,
                        props.formScalingFactor
                      );
                    }}
                  >
                    Scale
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Tab>
        </Tabs>
      )}
    </div>
  );
}
